import NoSelling from './no-selling'
import NowOnSale from './now-on-sale'

export default interface SaleStatus {
  readonly isOnSale: boolean
}

export const nowOnSale = new NowOnSale()
export const noSelling = new NoSelling()
